import React, { useState } from "react";
import { leadStatusMap } from "../Constant/Constant";

const LeadDirectionModal = ({ isOpen, onClose, selectedStatusId, totalLead, onConfirm }) => {
  const [selectedOption, setSelectedOption] = useState("view");


  if (!isOpen) return null;

  const handleSelect = (option) => {
    setSelectedOption(option);
    onConfirm(option);
    onClose();
  };



  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white w-[90%] sm:w-[50%] md:w-[40%] lg:w-[30%] py-8 px-6 rounded-lg shadow-lg">


        <div className="flex justify-between items-center border-b pb-3">
          <div></div>
          <h2 className="text-lg font-semibold text-gray-800">
            {leadStatusMap[selectedStatusId].label} Leads: {totalLead}
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-2xl">
            &times;
          </button>
        </div>


        <div className="flex flex-col justify-center items-center gap-5 mt-6">


          {
            selectedStatusId === "unAssigned" ? (
              <>
               <button
              onClick={() => handleSelect("withTeam")}
              className="px-6 py-2 rounded-md w-full text-white text-lg font-medium transition-all duration-300 bg-customGreen"
            >
              Leads With Team
            </button>
            <button
              onClick={() => handleSelect("withoutTeam")}
              className="px-6 py-2 rounded-md w-full text-white text-lg font-medium transition-all duration-300 bg-customGreen"
            >
             Leads Without Team
            </button>
              </>
            ):
            (
             <>
              <button
              onClick={() => handleSelect("view")}
              className={`px-6 py-2 rounded-md w-full text-lg text-white font-medium transition-all duration-300 bg-customGreen`}
            >
              View Lead
            </button>
              {/* {(selectedStatusId !== "gJxbL16EjFbzDFCoQU5G" && selectedStatusId !== "znvixWClH1PDoCXO4Aat" ) && (
                <button
                  onClick={() => handleSelect("reassign")}
                  className="px-6 py-2 rounded-md w-full text-white text-lg font-medium transition-all duration-300 bg-customGreen"
                >
                  Reassign Lead
                </button>
              )} */}
             </>
            )
          }



{/*
          <button
            onClick={() => handleSelect("bulk")}
            className={`px-6 py-2 rounded-md w-full text-white text-lg font-medium transition-all duration-300 bg-customGreen`}
          >
            Bulk Action on Leads
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default LeadDirectionModal;
